import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux'
import HttpService from '../../services/httpService'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import moment from 'moment';
import { Link } from "react-router-dom";
import { ROLENAME } from '../../utils';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Button, Dialog,
    DialogContent, DialogActions, Chip, Box, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
// Material icons throughout instead of the Ant Design outlined set. The two
// families have different stroke weights and corner radii, so mixing them with
// the MUI controls already on this page made it look assembled from spare
// parts - the same swap made across the call-recording, referral and
// complimentary-approval pages.
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';
import TuneIcon from '@material-ui/icons/Tune';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Tooltip from '@material-ui/core/Tooltip';

// Brand orange - sampled from the actual Decorpot logo, same palette used
// across the rest of the app's recently-redesigned pages.
const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const GREEN = "#1e8449";
const GREEN_LIGHT = "#eafaf1";
const GREEN_GRADIENT = `linear-gradient(135deg, #146c43, ${GREEN})`;
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";
// Matches the "Silka bold" heading treatment used on the lead details
// (manageProjectLog) page, so headings here read consistently with the rest
// of the app. Body text already inherits "Silka regular" globally via App.css.
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Two-letter monogram for the requester / assignee cells.
const initialsOf = (name = "") =>
    String(name).trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

const useStyles = makeStyles(() => ({
    page: { padding: 20, background: "#f6f7fb", minHeight: "100vh" },
    headerCard: {
        marginBottom: 20,
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 10px 28px rgba(196,83,31,0.2)",
        background: HEADER_GRADIENT,
        padding: "22px 26px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
    },
    headerLeft: { display: "flex", alignItems: "center", gap: 16 },
    headerActions: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
    "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
    "@keyframes pulseDot": {
        "0%, 100%": { opacity: 1, transform: "scale(1)" },
        "50%": { opacity: 0.45, transform: "scale(0.82)" },
    },
    // Solid white with a dark ring: the ring defines the EDGE, since white on
    // the bright #ff9c66 end of the gradient is only about 2:1. The word
    // "Refresh" is what makes the control findable at all.
    refreshButton: {
        display: "inline-flex", alignItems: "center", gap: 7,
        padding: "8px 16px", borderRadius: 999, border: "none",
        background: "#fff", color: ORANGE_DARK,
        fontSize: 12.5, fontWeight: 800, letterSpacing: 0.2, fontFamily: "inherit",
        cursor: "pointer",
        boxShadow: "0 0 0 1px rgba(0,0,0,0.14), 0 3px 10px rgba(0,0,0,0.24)",
        transition: "background .18s ease, transform .18s ease, box-shadow .18s ease",
        "&:hover:not(:disabled)": {
            background: ORANGE_LIGHT, transform: "translateY(-1px)",
            boxShadow: "0 0 0 1px rgba(0,0,0,0.18), 0 6px 16px rgba(0,0,0,0.3)",
        },
        "&:active:not(:disabled)": { transform: "translateY(0)" },
        "&:disabled": { cursor: "wait", opacity: 0.85 },
    },
    refreshSpinning: { animation: "$spin 0.9s linear infinite" },
    lastUpdatedText: {
        display: "inline-flex", alignItems: "center", gap: 6,
        fontSize: 11, fontWeight: 600, color: "#fff",
        background: "rgba(0,0,0,0.42)", padding: "3px 10px", borderRadius: 999,
        whiteSpace: "nowrap",
    },
    liveDot: {
        width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
        background: "#FFD2B5", animation: "$pulseDot 2s ease-in-out infinite",
    },
    headerIconWrap: {
        width: 52,
        height: 52,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.22)",
        border: "2px solid rgba(255,255,255,0.35)",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    statChip: {
        background: "rgba(255,255,255,0.2)",
        color: "#fff",
        borderRadius: 20,
        padding: "7px 16px",
        fontWeight: 700,
        fontSize: 13,
        display: "flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
    },
    filterCard: {
        borderRadius: 16,
        boxShadow: "0 6px 20px rgba(17,24,39,0.06)",
        padding: "18px 22px",
        marginBottom: 20,
        background: "#fff",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
    },
    sectionLabel: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        color: "#6b7280",
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.4,
        marginRight: 4,
    },
    field: {
        // Fixed width, no flex-grow - this shouldn't stretch to fill
        // whatever space is left in the filter row.
        width: 280,
        flex: "0 0 auto",
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ORANGE },
        '& .MuiInputLabel-root.Mui-focused': { color: ORANGE_DARK },
    },
    actionBtnBase: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
        boxShadow: "none",
        padding: "8px 20px",
        height: 40,
    },
    downloadBtn: {
        color: "#fff",
        background: GREEN_GRADIENT,
        "&:hover": { background: "linear-gradient(135deg, #0f5132, #146c43)", boxShadow: "0 6px 16px rgba(30,132,73,0.35)" },
    },
    logsBtn: {
        color: "#fff",
        background: `linear-gradient(135deg, ${ORANGE_DARK}, ${ORANGE})`,
        "&:hover": { background: `linear-gradient(135deg, #a8441a, ${ORANGE_DARK})`, boxShadow: "0 6px 16px rgba(244,126,68,0.35)" },
    },
    tableCard: { borderRadius: 16, overflow: "hidden", boxShadow: "0 6px 20px rgba(17,24,39,0.06)", background: "#fff" },
    tableWrap: { maxHeight: 850, overflow: "auto" },
    tableHeadCell: {
        // Solid, not a gradient: across a wide table the gradient's light end
        // left the right-hand headers washed out (white on #ff9c66 is only
        // ~2:1), and a flat band keeps every label at 4.64:1.
        // `!important` is still needed: MUI's stickyHeader rule paints its
        // own background on th.
        background: `${ORANGE_DARK} !important`,
        color: "#fff",
        fontWeight: 700,
        fontSize: 11.5,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        textAlign: "center",
        whiteSpace: "nowrap",
        borderBottom: "none",
    },
    tableRow: {
        "&:nth-of-type(odd)": { backgroundColor: "#FBFBFA" },
        "&:hover": { backgroundColor: ORANGE_LIGHT, boxShadow: `inset 3px 0 0 ${ORANGE}` },
        transition: "background-color .12s ease, box-shadow .12s ease",
    },
    tableCellCss: {
        textAlign: 'center',
        fontSize: 13.5,
        color: "#2b3648",
        borderBottom: "1px solid #f1f2f5",
    },
    rankCell: { color: "#9aa1ac", fontWeight: 800, fontVariantNumeric: "tabular-nums" },
    logsSubtitle: { fontSize: 12.5, color: "rgba(255,255,255,0.85)", marginTop: 2 },
    logsSummary: {
        display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center",
        padding: "10px 16px", background: "#FBFBFA", borderBottom: "1px solid #eef0f3",
    },
    summaryPill: {
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "4px 12px", borderRadius: 999,
        fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
    },
    // Bounded so a long history scrolls inside the modal rather than pushing
    // the close button off the bottom of the screen.
    logsTableWrap: { maxHeight: "52vh", overflow: "auto" },
    logsEmpty: { padding: "52px 24px", textAlign: "center" },
    logsEmptyIcon: {
        width: 64, height: 64, borderRadius: "50%", margin: "0 auto 14px",
        display: "flex", alignItems: "center", justifyContent: "center",
        background: ORANGE_LIGHT, border: `1px solid ${ORANGE}33`,
    },
    // Identity, not decoration: the same requester and assignee recur down the
    // list, and an initial makes a repeated name findable while scanning.
    personCell: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8 },
    personAvatar: {
        width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: ORANGE_LIGHT, color: ORANGE_DARK,
        fontSize: 11, fontWeight: 800,
    },
    // Grand totals are compared down the column, so tabular figures -
    // proportional digits meant the amounts never lined up.
    amountCell: {
        fontWeight: 800, color: "#2b3648",
        fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap",
    },
    dateStack: { lineHeight: 1.35 },
    dateMain: { fontSize: 12.5, fontWeight: 700, color: "#2b3648", whiteSpace: "nowrap" },
    dateSub: { fontSize: 11, color: "#9aa1ac", whiteSpace: "nowrap" },
    // A tinted pill with a launch glyph, matching the BotWot dashboard: the
    // lead number reads as the thing you click, not as underlined text.
    leadLink: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "3px 10px",
        borderRadius: 7,
        background: ORANGE_LIGHT,
        whiteSpace: "nowrap",
        color: ORANGE_DARK,
        fontWeight: 700,
        fontSize: 12.5,
        textDecoration: "none",
        transition: "background-color .15s ease",
        "&:hover": { background: "#ffe3d2", textDecoration: "none" },
    },
    discountChip: {
        background: ORANGE_LIGHT,
        color: ORANGE_DARK,
        fontWeight: 700,
    },
    infoIconBtn: {
        color: ORANGE_DARK,
        cursor: "pointer",
        fontSize: 16,
    },
    emptyState: { padding: "60px 20px", textAlign: "center", color: "#9aa1ac" },
    emptyIconWrap: {
        width: 80,
        height: 80,
        borderRadius: "50%",
        background: ORANGE_LIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 14px",
    },
    dialogHeader: {
        background: HEADER_GRADIENT,
        color: "#fff",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    dialogHeaderTitle: { display: "flex", alignItems: "center", gap: 10 },
    dialogCloseBtn: {
        color: "rgba(255,255,255,0.9)",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
    },
    approveBtn: {
        color: "#fff",
        background: GREEN_GRADIENT,
        "&:hover": { background: "linear-gradient(135deg, #0f5132, #146c43)", boxShadow: "0 6px 16px rgba(30,132,73,0.3)" },
    },
    rejectBtn: {
        color: RED,
        border: `1.5px solid ${RED}`,
        background: "#fff",
        "&:hover": { background: RED_LIGHT },
    },
    discountBanner: {
        textAlign: "center",
        padding: "24px 20px",
    },
    discountBannerPercent: {
        fontSize: 42,
        fontWeight: 800,
        color: ORANGE_DARK,
        lineHeight: 1,
    },
}));

const DiscountApproval = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);

    const isAdmin = userDetails?.roles?.some(
        role => role.name === ROLENAME.Admin
    );

    const [discountedProjectLists, setDiscountedProjectLists] = useState([]);
    const [openProjectLogsModal, setOpenProjectLogsModal] = useState(false);
    const [openProjectInfoModal, setOpenProjectInfoModal] = useState(false);
    const [projectLogsData, setProjectLogsData] = useState([]);
    // The lead whose history is open, for the modal's subtitle.
    const [logsLead, setLogsLead] = useState(null);
    const [projectDiscount, setProjectDiscount] = useState(0);
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [projectId, setProjectId] = useState("");
    // Local, in-table loader - the app-wide Backdrop was previously fired
    // alongside this same `loading` state, which meant this spinner (and
    // the empty state below it) never actually got a chance to render since
    // the Backdrop covers the whole screen first. Local-only now, so it's
    // actually visible.
    const [loading, setLocalLoading] = useState(false)
    const [approving, setApproving] = useState(false)
    // When the rows on screen were last pulled, so the header can say how stale
    // they are. Only set on a successful fetch - a failed refresh must not make
    // old rows look fresh.
    const [lastUpdated, setLastUpdated] = useState(null);
    // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
    // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
    const [nowTick, setNowTick] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);
    // The centres the visible rows were fetched with, so Refresh repeats the
    // same query instead of silently dropping the filter.
    const [appliedExpCenter, setAppliedExpCenter] = useState(undefined);

    const [data, setData] = useState({
        discountPercent: "",
        projectId: "",
        assignTo: "",
        discountRequestedBy: "",
        discountApprovalRequest: "",
        discountStatus: ""
    });

    useEffect(() => {
        discountedProject()
        expCenters();
        // eslint-disable-next-line
    }, [])

    const discountedProject = async (selectedExpCenter) => {
        setLocalLoading(true);
        let expCenterData = selectedExpCenter?.map((el) => el._id)

        try {
            let expCenterId = expCenterData?.length > 0
                ? expCenterData
                : userDetails.selectedExpCenter

            const response = await HttpService.discountedProject(expCenterId);

            setDiscountedProjectLists(
                response.data === 'No projects found.' ? [] : response.data
            );
            // After the assignment, inside the try: a fetch that threw leaves
            // the previous timestamp alone rather than vouching for stale rows.
            setLastUpdated(new Date());
            setAppliedExpCenter(selectedExpCenter);

        } catch (error) {
            console.error(error, "Discounted Project not found")
        }
        setLocalLoading(false);
    }

    // Takes the whole row, not just the log array: the modal needs to name the
    // lead it is describing. Opened from a table of many leads, "Project Logs"
    // alone left no way to tell whose history you were reading.
    const showProjectLogs = (row) => {
        setOpenProjectLogsModal(true);
        setProjectLogsData(row?.discountLogs || []);
        setLogsLead(row || null);
    }

    const showInfo = (row) => {
        setProjectDiscount(row?.discountPercent)
        setProjectId(row?._id);

        setData({
            discountPercent: row?.discountPercent,
            assignTo: row?.assignTo?._id,
            discountRequestedBy: row?.discountRequestedBy?._id || ''
        });

        setOpenProjectInfoModal(true);
    }

    const handleMultipleExpData = (e, val) => {
        setSelectedExperienceCenter(val)
        discountedProject(val)
    }
    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user =>
                userDetails.experienceCenterId.includes(user._id)
            );
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const approveDiscount = async (status) => {
        data.discountApprovalRequest = status;
        data.discountStatus = status ? 'Rejected' : 'Approved'

        setApproving(true);
        try {
            await HttpService.approveDiscount(projectId, data);
            discountedProject()
            setOpenProjectInfoModal(false);
        } catch (error) {
            console.error(error, "Discounted Project not found")
        }
        setApproving(false);
    }

    const downloadCSV = () => {
        if (!discountedProjectLists.length) return;

        const headers = ["Sl No", "Customer", "EC", "Lead No", "Created At", "Budget", "Discount %", "Requested By", "Assigned To"];

        const rows = discountedProjectLists.map((row, i) => [
            i + 1,
            row?.customerId?.name,
            row?.experienceCenterId?.name,
            row?.lead_no,
            moment(row?.createdAt).format('DD-MM-YYYY'),
            row?.grandTotal,
            row?.discountPercent,
            row?.discountRequestedBy?.name,
            row?.assignTo?.name
        ]);

        let csvContent =
            "data:text/csv;charset=utf-8," +
            [headers, ...rows].map(e => e.join(",")).join("\n");

        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "discounted_projects.csv";
        link.click();
    };

    const canViewPage = userDetails?.roles &&
        userDetails.roles.some(role =>
            [
                ROLENAME.DGM_Sales,
                ROLENAME.SalesHead,
                ROLENAME.DGM_Design,
                ROLENAME.AGM_Sales,
                ROLENAME.CenterHead,
                ROLENAME.Admin
            ].includes(role.name)
        );

    return (
        <div className={classes.page}>

            {canViewPage && (
                <>
                    {/* HEADER */}
                    <Box className={classes.headerCard}>
                        <Box className={classes.headerLeft}>
                            <Box className={classes.headerIconWrap}>
                                <LocalOfferOutlinedIcon style={{ color: "#fff", fontSize: 26 }} />
                            </Box>
                            <Box>
                                <Typography style={{ color: "#fff", fontFamily: HEADING_FONT, fontSize: 21, margin: 0 }}>
                                    Discount Approvals
                                </Typography>
                                <Typography style={{ color: "rgba(255,255,255,0.88)", fontSize: 13.5, marginTop: 4 }}>
                                    Review and action discount requests raised on projects
                                </Typography>
                            </Box>
                        </Box>

                        <Box className={classes.headerActions}>
                            <Box className={classes.statChip}>
                                <LocalOfferOutlinedIcon style={{ fontSize: 15 }} />
                                {discountedProjectLists.length} Pending Request{discountedProjectLists.length === 1 ? "" : "s"}
                            </Box>

                            <Tooltip
                                title={
                                    lastUpdated
                                        ? `Last pulled at ${moment(lastUpdated).format("DD MMM YYYY, hh:mm:ss A")} — click to fetch the latest requests`
                                        : "Fetch the latest requests"
                                }
                            >
                                {/* A labelled button rather than an IconButton: the
                                    word "Refresh" is what makes the control findable,
                                    and a tooltip alone only helps people who already
                                    hovered. The span is required because a disabled
                                    button fires no mouse events, so the tooltip would
                                    die exactly mid-refresh. */}
                                <span style={{ display: "inline-flex" }}>
                                    <button
                                        type="button"
                                        className={classes.refreshButton}
                                        onClick={() => discountedProject(appliedExpCenter)}
                                        disabled={loading}
                                    >
                                        <RefreshIcon
                                            className={loading ? classes.refreshSpinning : undefined}
                                            style={{ fontSize: 17 }}
                                        />
                                        {loading ? "Refreshing…" : "Refresh"}
                                    </button>
                                </span>
                            </Tooltip>

                            {lastUpdated && (
                                <Box className={classes.lastUpdatedText}>
                                    <span className={classes.liveDot} />
                                    {/* Relative beats a clock time: it answers "is
                                        this stale?" without the reader doing the
                                        arithmetic. */}
                                    {loading ? "Fetching latest…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
                                </Box>
                            )}
                        </Box>
                    </Box>

                    {/* FILTERS */}
                    <Box className={classes.filterCard}>
                        <Typography className={classes.sectionLabel}>
                            <TuneIcon style={{ fontSize: 15 }} />
                            Filters
                        </Typography>

                        <FormControl className={classes.field}>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filter by Experience Center"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <StorefrontOutlinedIcon style={{ fontSize: 16, color: "#9aa1ac", marginRight: 4 }} />
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>

                        <Box style={{ flex: 1 }} />

                        <Button
                            variant="contained"
                            onClick={downloadCSV}
                            disabled={!discountedProjectLists.length}
                            className={`${classes.actionBtnBase} ${classes.downloadBtn}`}
                            startIcon={<GetAppIcon />}
                        >
                            Download CSV
                        </Button>
                    </Box>

                    {/* TABLE */}
                    <Box className={classes.tableCard}>
                        {loading ? (
                            <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 0" }}>
                                <CircularProgress style={{ color: ORANGE }} />
                                <Typography style={{ color: "#9aa1ac", marginTop: 10 }}>Loading discount requests...</Typography>
                            </Box>
                        ) : discountedProjectLists.length === 0 ? (
                            <Box className={classes.emptyState}>
                                <Box className={classes.emptyIconWrap}>
                                    <InboxOutlinedIcon style={{ fontSize: 36, color: ORANGE_DARK }} />
                                </Box>
                                <Typography style={{ fontWeight: 600, color: "#7d8794" }}>
                                    No Discount Approvals Found
                                </Typography>
                                <Typography variant="body2" style={{ color: "#a4abb5", marginTop: 4 }}>
                                    There are currently no projects requiring discount approval.
                                </Typography>
                            </Box>
                        ) : (
                            <TableContainer className={classes.tableWrap}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                "Sl No",
                                                "Customer",
                                                "Experience Center",
                                                "Lead No",
                                                "Created At",
                                                "Budget",
                                                "Discount %",
                                                "Requested By",
                                                "Assigned To",
                                                "Logs"
                                            ].map((h, i) => (
                                                <TableCell key={i} className={classes.tableHeadCell}>
                                                    {h}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {discountedProjectLists.map((row, i) => (
                                            <TableRow key={i} className={classes.tableRow}>

                                                <TableCell className={`${classes.tableCellCss} ${classes.rankCell}`}>{i + 1}</TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    <strong style={{ fontWeight: 600 }}>{row?.customerId?.name || "NA"}</strong>
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss} style={{ color: "#6b7280" }}>
                                                    {row?.experienceCenterId?.name || "NA"}
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    <Tooltip title={`Open lead ${row?.lead_no ?? ""} in a new tab`}>
                                                        <Link
                                                            to={`/project-logs/${row._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className={classes.leadLink}
                                                        >
                                                            {row?.lead_no}
                                                            <OpenInNewIcon style={{ fontSize: 11 }} />
                                                        </Link>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    {row?.createdAt ? (
                                                        <div className={classes.dateStack}>
                                                            <div className={classes.dateMain}>{moment(row.createdAt).format('DD MMM YYYY')}</div>
                                                            <div className={classes.dateSub}>{moment(row.createdAt).fromNow()}</div>
                                                        </div>
                                                    ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                </TableCell>

                                                <TableCell className={`${classes.tableCellCss} ${classes.amountCell}`}>
                                                    {row?.grandTotal != null
                                                        ? `₹${Number(row.grandTotal).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`
                                                        : <span style={{ color: "#9aa1ac", fontWeight: 400 }}>NA</span>}
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    <Chip
                                                        label={`${row?.discountPercent || 0}%`}
                                                        size="small"
                                                        className={classes.discountChip}
                                                    />
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    {row?.discountRequestedBy?.name ? (
                                                        <div className={classes.personCell}>
                                                            <span className={classes.personAvatar}>{initialsOf(row.discountRequestedBy.name)}</span>
                                                            <span>{row.discountRequestedBy.name}</span>
                                                        </div>
                                                    ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    <Box style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        gap: 6
                                                    }}>
                                                        {row?.assignTo?.name ? (
                                                            <div className={classes.personCell}>
                                                                <span className={classes.personAvatar}>{initialsOf(row.assignTo.name)}</span>
                                                                <span>{row.assignTo.name}</span>
                                                            </div>
                                                        ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                        {!isAdmin && (
                                                            <Tooltip title="Review and action this discount request">
                                                                <InfoOutlinedIcon
                                                                    className={classes.infoIconBtn}
                                                                    onClick={() => showInfo(row)}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                </TableCell>

                                                <TableCell className={classes.tableCellCss}>
                                                    {/* The count sits on the button so a lead with no
                                                        history is obvious from the table - you no
                                                        longer have to open a modal to find out there
                                                        is nothing in it. */}
                                                    <Tooltip
                                                        title={
                                                            (row?.discountLogs?.length || 0) === 0
                                                                ? "No discount decisions recorded on this lead yet"
                                                                : `See all ${row.discountLogs.length} discount decision${row.discountLogs.length === 1 ? "" : "s"} on this lead`
                                                        }
                                                    >
                                                        <Button
                                                            onClick={() => showProjectLogs(row)}
                                                            variant="contained"
                                                            size="small"
                                                            className={`${classes.actionBtnBase} ${classes.logsBtn}`}
                                                            style={{
                                                                padding: "6px 14px",
                                                                height: "auto",
                                                                // Muted, not disabled - opening it is
                                                                // still allowed, and the modal then
                                                                // explains why it is empty.
                                                                opacity: (row?.discountLogs?.length || 0) === 0 ? 0.55 : 1,
                                                            }}
                                                            startIcon={<DescriptionOutlinedIcon />}
                                                        >
                                                            View Logs
                                                            {(row?.discountLogs?.length || 0) > 0 && ` · ${row.discountLogs.length}`}
                                                        </Button>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </>
            )}

            {/* LOGS MODAL */}
            <Dialog open={openProjectLogsModal} onClose={() => setOpenProjectLogsModal(false)} maxWidth="md" fullWidth PaperProps={{ style: { borderRadius: 16, overflow: "hidden" } }}>
                <Box className={classes.dialogHeader}>
                    <Box className={classes.dialogHeaderTitle}>
                        <DescriptionOutlinedIcon style={{ fontSize: 22 }} />
                        <Box>
                            <Typography style={{ fontFamily: HEADING_FONT, fontSize: 17 }}>Discount History</Typography>
                            {logsLead && (
                                <Typography className={classes.logsSubtitle}>
                                    Lead {logsLead?.lead_no ?? "—"}
                                    {logsLead?.customerId?.name ? ` · ${logsLead.customerId.name}` : ""}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={() => setOpenProjectLogsModal(false)}>
                        <CloseIcon style={{ fontSize: 18 }} />
                    </IconButton>
                </Box>

                <DialogContent style={{ padding: 0 }}>
                    {projectLogsData.length === 0 ? (
                        // The table used to render a header with nothing beneath
                        // it, which reads as a failed load rather than as a lead
                        // nobody has decided on yet.
                        <Box className={classes.logsEmpty}>
                            <Box className={classes.logsEmptyIcon}>
                                <DescriptionOutlinedIcon style={{ fontSize: 30, color: ORANGE_DARK }} />
                            </Box>
                            <Typography style={{ fontSize: 16, fontWeight: 700, color: "#334155" }}>
                                No discount decisions yet
                            </Typography>
                            <Typography style={{ fontSize: 13, color: "#9aa1ac", marginTop: 6, maxWidth: 420, margin: "6px auto 0" }}>
                                Nobody has approved or rejected a discount on
                                {logsLead?.lead_no ? ` lead ${logsLead.lead_no}` : " this lead"} so far.
                                Entries appear here as soon as the first decision is taken.
                            </Typography>
                        </Box>
                    ) : (
                    <>
                    <Box className={classes.logsSummary}>
                        <span className={classes.summaryPill} style={{ background: "#eef2f8", color: "#2a4d7a" }}>
                            {projectLogsData.length} decision{projectLogsData.length === 1 ? "" : "s"}
                        </span>
                        <span className={classes.summaryPill} style={{ background: GREEN_LIGHT, color: GREEN }}>
                            <CheckCircleOutlineIcon style={{ fontSize: 14 }} />
                            {projectLogsData.filter((l) => l?.approvalStatus).length} approved
                        </span>
                        <span className={classes.summaryPill} style={{ background: RED_LIGHT, color: RED }}>
                            <HighlightOffIcon style={{ fontSize: 14 }} />
                            {projectLogsData.filter((l) => !l?.approvalStatus).length} rejected
                        </span>
                    </Box>
                    <TableContainer className={classes.logsTableWrap}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {["Sl No", "Discount", "Status", "Assigned To", "Requested By", "Action Taken By"]
                                        .map((h, i) => (
                                            <TableCell key={i} className={classes.tableHeadCell}>{h}</TableCell>
                                        ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {projectLogsData.map((row, i) => (
                                    <TableRow key={i} className={classes.tableRow}>
                                        <TableCell className={`${classes.tableCellCss} ${classes.rankCell}`}>{i + 1}</TableCell>

                                        <TableCell className={classes.tableCellCss}>
                                            <Chip label={`${row?.discountValue ?? 0}%`} size="small" className={classes.discountChip} />
                                        </TableCell>

                                        <TableCell className={classes.tableCellCss}>
                                            <Chip
                                                label={row?.approvalStatus ? "Approved" : "Rejected"}
                                                size="small"
                                                icon={row?.approvalStatus ? <CheckCircleOutlineIcon style={{ fontSize: 14 }} /> : <HighlightOffIcon style={{ fontSize: 14 }} />}
                                                style={{
                                                    background: row?.approvalStatus ? GREEN_LIGHT : RED_LIGHT,
                                                    color: row?.approvalStatus ? GREEN : RED,
                                                    fontWeight: 700,
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell className={classes.tableCellCss}>
                                            {row?.user?.name ? (
                                                <div className={classes.personCell}>
                                                    <span className={classes.personAvatar}>{initialsOf(row.user.name)}</span>
                                                    <span>{row.user.name}</span>
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {row?.discountRequestedBy?.name ? (
                                                <div className={classes.personCell}>
                                                    <span className={classes.personAvatar}>{initialsOf(row.discountRequestedBy.name)}</span>
                                                    <span>{row.discountRequestedBy.name}</span>
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {row?.actionTakenBy?.name ? (
                                                <div className={classes.personCell}>
                                                    <span className={classes.personAvatar}>{initialsOf(row.actionTakenBy.name)}</span>
                                                    <span>{row.actionTakenBy.name}</span>
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </>
                    )}
                </DialogContent>
            </Dialog>

            {/* DEAL MODAL */}
            {!isAdmin && (
                <Dialog open={openProjectInfoModal} onClose={() => !approving && setOpenProjectInfoModal(false)} PaperProps={{ style: { borderRadius: 16, overflow: "hidden", minWidth: 380 } }}>
                    <Box className={classes.dialogHeader}>
                        <Box className={classes.dialogHeaderTitle}>
                            <LocalOfferOutlinedIcon style={{ fontSize: 22 }} />
                            <Typography style={{ fontFamily: HEADING_FONT, fontSize: 17 }}>Deal Discount</Typography>
                        </Box>
                        <IconButton
                            size="small"
                            className={classes.dialogCloseBtn}
                            onClick={() => setOpenProjectInfoModal(false)}
                            disabled={approving}
                        >
                            <CloseIcon style={{ fontSize: 18 }} />
                        </IconButton>
                    </Box>

                    <DialogContent className={classes.discountBanner}>
                        <Typography className={classes.discountBannerPercent}>
                            {projectDiscount}%
                        </Typography>
                        <Typography variant="body2" style={{ color: "#6b7280", marginTop: 6 }}>
                            discount requested for this customer
                        </Typography>
                    </DialogContent>

                    <DialogActions style={{ padding: "14px 24px 20px", justifyContent: "center" }}>
                        <Button
                            onClick={() => approveDiscount(true)}
                            variant="outlined"
                            disabled={approving}
                            className={classes.rejectBtn}
                            startIcon={<HighlightOffIcon />}
                        >
                            Reject
                        </Button>

                        <Button
                            onClick={() => approveDiscount(false)}
                            variant="contained"
                            disabled={approving}
                            className={classes.approveBtn}
                            startIcon={approving ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <CheckCircleOutlineIcon />}
                        >
                            {approving ? "Submitting..." : "Approve"}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(DiscountApproval);
